/**
 * GenericSimulatorApi.ts — Central API handler for GenericSimulator module
 *
 * All API calls used by the GenericSimulator are routed through this file.
 * API definitions live in SimulateService; this file handles calling them
 * and provides a single import point for the module.
 *
 * APIs:
 *  - getDeploymentDetails()          : Fetches deployment assets for a scenario (both summary & running).
 *  - undeployScenario()               : Undeploys a running scenario (End Simulation).
 *  - getVisualizationElements()       : Fetches visualization element data for summary replay.
 */

import SimulateService from '../../../service/SimulateService';

/**
 * Fetch deployment details (assets) for a given mission + scenario.
 * GET /v3/simulate/{missionId}/scenario/{scenarioId}/deploymentdetails
 */
export const getDeploymentDetails = (missionId: string, scenarioId: string) => {
    return SimulateService.getManualScenario(missionId, scenarioId);
};

/**
 * Undeploy a running manual scenario.
 * POST /v2/simulate/{missionId}/scenario/{scenarioId}/undeploy
 */
export const undeployScenario = (missionId: string, scenarioId: string) => {
    return SimulateService.unDeployManualScenario(missionId, scenarioId);
};

/**
 * Fetch visualization element data for summary replay.
 * GET /v3/simulate/{missionId}/scenario/{scenarioId}/elements/visualization?compression=gzip
 */
export const getVisualizationElements = (missionId: string, scenarioId: string) => {
    return SimulateService.getVisualizationElements(missionId, scenarioId);
};

/**
 * Fetch Grafana dashboard data for a manual scenario.
 * GET /test/v3/{missionId}/scenario/{scenarioId}/grafana
 */
export const getGrafanaData = (missionId: string, scenarioId: string) => {
    return SimulateService.getGrafanaDataForManualScenario(missionId, scenarioId);
};
